export default __webpack_public_path__ + "static/media/BH.f75f5a7f.svg";